import React from 'react';
import { t } from '@lingui/macro';

import { Box, Button } from '@rover/kibble/core';
import { DSTokenMap } from '@rover/kibble/styles';
import { isReactNative } from '@rover/rsdk/src/modules/Env/react';

export interface SaveButtonProps {
  disabled?: boolean;
  loading?: boolean;
  onClick?: () => void;
  label?: string;
}

const SaveButton: React.FC<SaveButtonProps> = ({ disabled, loading, onClick, label = t`Save` }) => {
  return (
    <Box
      borderTopWidth={isReactNative() ? '1px' : '0'}
      borderTopColor={DSTokenMap.BORDER_COLOR_PRIMARY.toString()}
      px={isReactNative() ? '5x' : '0x'}
      py="6x"
    >
      <Button
        disabled={disabled}
        loading={loading}
        onClick={onClick}
        variant="primary"
        fullWidth
        size={isReactNative() ? 'default' : 'small'}
      >
        {label}
      </Button>
    </Box>
  );
};

export default SaveButton;
